<!-- SIDEBAR HEADER -->
<div class="header accent p-24" fxLayout="column" fxLayoutAlign="space-between">

    <div class="toolbar" fxLayout="row" fxLayoutAlign="end center">

        <button mat-icon-button aria-label="Download" matTooltip="Download" (click)="onDownload(selected)" [disabled]="selected.type=='folder' || selected.type=='Voltar' ">
            <mat-icon style="font-size: 30px;">cloud_download</mat-icon>
        </button>

        <button color='warn' mat-icon-button matTooltip="Excluir" (click)="onDelete(selected)" [disabled]="selected.type=='Voltar'"  *ngIf="usuario.tipo_usuario_id == 2 || usuario.tipo_usuario_id == 3 || selected.owner == usuario.name ">
            <mat-icon style="font-size: 30px;">delete</mat-icon>
        </button>

    </div>

    <div>
        <div class="title mb-8">{{selected.name}}</div>
        <div class="subtitle secondary-text">
            <span>Modificado</span>
            <span>: {{selected.modified}}</span>
        </div>
    </div>
</div>
<!-- / SIDEBAR HEADER -->

<!-- SIDEBAR CONTENT -->
<div class="content p-24" fusePerfectScrollbar>

    <div class="file-details" [@animate]="{value:'*',params:{delay:'200ms'}}">

        <div class="preview file-icon" fxLayout="row" fxLayoutAlign="center center">
            <mat-icon class="type-icon s-48" [ngClass]="selected.type"></mat-icon>
        </div>

        <div class="title">Informações:</div>

        <table>
            <tr class="type">
                <th>Tipo</th>
                <td>{{selected.tipo}}</td>
            </tr>

            <tr class="size">
                <th>Tamanho</th>
                <td>{{selected.size === '' ? '-': selected.size}}</td>
            </tr>

            <tr class="location">
                <th>Localização</th>
                <td>{{selected.location}}</td>
            </tr>

            <tr class="owner">
                <th>Proprietário</th>
                <td>{{selected.owner}}</td>
            </tr>

            <tr class="modified">
                <th>Modificado em</th>
                <td>{{selected.modified}}</td>
            </tr>

            <tr class="created">
                <th>Criado em</th>
                <td>{{selected.created}}</td>
            </tr>
        </table>
    </div>

</div>
<!-- / SIDEBAR CONTENT -->
